import { create } from 'zustand';

export const tourItems = [
  'WELCOME_MODAL',
  'WRITE_QUESTION',
  'EDIT_CONTENT',
  'EDIT_OPTIONS',
  'PRESS_PRESENT',
  'QR_CODE',
  'NAVIGATION_ARROWS',
  'FINISH_MODAL',
] as const;

export type TourItemKey = (typeof tourItems)[number];

export const TOUR_LENGTH = tourItems.length - 2; // Exclude welcome and finish modals

interface TourState {
  activeTourItem: TourItemKey | null;
  appliedQuickAction: 'poll' | 'wordcloud' | null;
  setActiveTourItem: (tourItem: TourItemKey | null) => void;
  setAppliedQuickAction: (action: 'poll' | 'wordcloud' | null) => void;
}

export const useTourStore = create<TourState>((set, get) => ({
  appliedQuickAction: null,
  activeTourItem: null,

  setActiveTourItem: (tourItem: TourItemKey | null) => {
    set({ activeTourItem: tourItem });
  },
  setAppliedQuickAction: (action: 'poll' | 'wordcloud' | null) => {
    set({ appliedQuickAction: action });
  },
}));
